console.log("Free Shipping JS cargado");

document.addEventListener("DOMContentLoaded", async () => {

    const bar = document.getElementById("FreeShippingBar");

    if (!bar) return;

    const message = document.getElementById("FreeShippingMessage");
    const fill = document.getElementById("FreeShippingFill");

    // Meta para envío gratis (en pesos)
    const goal = Number(bar.dataset.goal);

    try {

        // Obtiene el carrito actual
        const response = await fetch("/cart.js");
        const cart = await response.json();

        // Shopify devuelve centavos
        const total = cart.total_price / 100;

        const percent = Math.min((total / goal) * 100, 100);

        fill.style.width = percent + "%";

        if (total >= goal) {

            bar.classList.add("success");

            message.innerHTML =
                "🎉 ¡Felicidades! Ya obtuviste envío GRATIS.";

        } else {

            const missing = (goal - total).toFixed(2);

            message.innerHTML =
                `🚚 Te faltan <strong>$${missing}</strong> para obtener envío GRATIS`;

        }

    } catch (error) {

        console.error("Error obteniendo carrito", error);

    }

});